import { Box, LinearProgress, Typography } from "@mui/material";
import { Field, Form, Formik, FormikHelpers } from "formik";
import React from "react";
import { SubmitButton } from "src/components/forms/SubmitButton";
import { CustomInput } from "../security/CustomInputField";
import * as Yup from "yup";
import { SmsStyles } from "../security/styles/smsStyles";

export interface TwoFADialogProps {
  onClose: () => void;
  handleSubmit: (
    values: { code: string },
    action: FormikHelpers<{
      code: string;
    }>,
  ) => void;
  setError: React.Dispatch<React.SetStateAction<string>>;
  error: string;
  showProgress: boolean;
}

export default function SixDigitsField(props: TwoFADialogProps) {
  const onlyNumbers = /^\d+$/;
  const classes = SmsStyles();
  const warningMessage = "Enter the code from your Authenticator app below.";

  const validationSchema = Yup.object().shape({
    code: Yup.string()
      .min(6)
      .max(6)
      .matches(
        // eslint-disable-next-line no-useless-escape
        onlyNumbers,
        "Should only contain numbers",
      )
      .required("Verification code is required"),
  });
  return (
    <Formik
      initialValues={{ code: "" }}
      onSubmit={(values, actions) => {
        props.handleSubmit(values, actions);
      }}
      validationSchema={validationSchema}>
      <Form style={{ width: "100%" }}>
        <Typography className={classes.fieldDescription}>{warningMessage}</Typography>
        <Field
          fullWidth
          as={CustomInput}
          name="code"
          height="10px"
          size={"small"}
          placeholder="Enter code"
          mb={4}
          error={props.error}
          setError={props.setError}
        />
        <SubmitButton
          fullWidth
          sx={{
            height: "45px",
            marginTop: "8px",
            fontWeight: "bold",
            borderRadius: "12px",
          }}>
          <Typography
            fontWeight={"700"}
            color={"#FFF"}
            fontSize="16px"
            textTransform={"capitalize"}>
            Confirm
          </Typography>
        </SubmitButton>
        {props.showProgress && (
          <Box py={2}>
            <LinearProgress />
          </Box>
        )}
      </Form>
    </Formik>
  );
}
